/**
 * @author        esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   MapBox Module Constants
 */

// mapbox data actions ==> these came from NR
export const UPDATE_WIDTH = '@@nr/MapBox/UPDATE_WIDTH'
export const UPDATE_HEIGHT = '@@nr/MapBox/UPDATE_HEIGHT'
export const UPDATE_DIMENSIONS = '@@nr/MapBox/UPDATE_DIMENSIONS'

export const RESET_CENTER = '@@nr/MapBox/RESET_CENTER'
export const UPDATE_CENTER = '@@nr/MapBox/UPDATE_CENTER'
export const UPDATE_LATITUDE = '@@nr/MapBox/UPDATE_LATITUDE'
export const UPDATE_LONGITUDE = '@@nr/MapBox/UPDATE_LONGITUDE'

export const UPDATE_ZOOM = '@@nr/MapBox/UPDATE_ZOOM'

export const UPDATE_BEARING = '@@nr/MapBox/UPDATE_BEARING'
export const UPDATE_PITCH = '@@nr/MapBox/UPDATE_PITCH'

// mapbox meta actions
export const UPDATE_BOX = '@@nzr/MainMap/UPDATE_BOX'

export const READY = '@@nzr/MainMap/READY'
export const NOT_READY = '@@nzr/MainMap/NOT_READY'

export const MOUNT = '@@nzr/MainMap/MOUNT'
export const UNMOUNT = '@@nzr/MainMap/UNMOUNT'

export const FREEZE_ZOOM = '@@nzr/MainMap/FREEZE_ZOOM'
export const THAW_ZOOM = '@@nzr/MainMap/THAW_ZOOM'

export const ENABLE_SYNC_ON_MOVE = '@@nzr/MainMap/ENABLE_SYNC_ON_MOVE'
export const DISABLE_SYNC_ON_MOVE = '@@nzr/MainMap/DISABLE_SYNC_ON_MOVE'

export const UNSYNC = '@@nzr/MainMap/UNSYNC'
export const SYNC = '@@nzr/MainMap/SYNC'

export const ENABLE_SYNC = '@@nzr/MainMap/ENABLE_SYNC'
export const DISABLE_SYNC = '@@nzr/MainMap/DISABLE_SYNC'

export const SHOW = '@@nzr/MainMap/SHOW'
export const HIDE = '@@nzr/MainMap/HIDE'

export const SET_TRANSITION_DURATION = '@@nzr/MainMap/SET_TRANSITION_DURATION'
export const REMOVE_TRANSITION_DURATION = '@@nzr/MainMap/REMOVE_TRANSITION_DURATION'

export const SYNC_ON_IDLE = '@@nzr/MainMap/SYNC_ON_IDLE'
export const IGNORE_ON_IDLE = '@@nzr/MainMap/IGNORE_ON_IDLE'

export const RESET_META = '@@nzr/MainMap/RESET_META'

export const SHOW_BOUNDS = '@@nzr/MainMap/SHOW_BOUNDS'
